<template>
    <v-app style="background-color: #f3f6f9">
        <v-main>
            <AllManuimComp />
        </v-main>
    </v-app>
</template>
<script>
import Auth from '@/services/auth.service.js'
import AllManuimComp from '@/components/manuim/AllManuimComp.vue'

export default {
    components: {
        AllManuimComp
    },
    mounted() {
        document.title = ' מנויים - ראשי | סים לחומרא'
        let auth = Auth.checkAuth();
        if (!auth) {
            return this.$router.replace({ name: "login" })
        }
    },
}
</script>
<style>
</style>